import { html } from 'lit-element';
import { productChangeFrequency } from '../core/actions';
import { FrequencyStatus, mapStateToProps, frequencyText } from './FrequencyStatus';
import { connect } from '../core/connect';

export const frequencyEquals = (a, b) => {
  if (a === null || b === null) return false;
  return a.every === b.every && a.period === b.period;
};

export class SelectFrequency extends FrequencyStatus {
  render() {
    const options = (this.frequencies || []).map(value => ({
      value: value,
      text: frequencyText(value, this.defaultFrequency)
    }));

    return html`
      <og-select
        .options="${options}"
        .selected="${this.frequency || this.defaultFrequency}"
        .onChange="${({ target: { value } }) => this.productChangeFrequency(this.product, value)}"
      ></og-select>
    `;
  }
}

export const ConnectedSelectFrequency = connect(
  mapStateToProps,
  { productChangeFrequency }
)(SelectFrequency);

export default ConnectedSelectFrequency;
